import type { AppManifestConfig } from "@shared/config/types";

const appConfig: AppManifestConfig = {
  pwaAppTitle: "Porsche",
  pwaAppDescription: "Chargemap and route planner",
  themeColor: "#FFFFFF",
  title: "Porsche",
  metaTags: {
    description: "Chargemap and route planner",
    keywords: "",
    robots: "noindex,nofollow",
  },
  openGraphTags: {
    title: "Taycan route planner",
    description:
      "Plan a route with one of the Porsche Taycan models. Charge map includes Porsche destination chargers.",
    type: "website",
    site_name: "Porsche",
    image: "",
    "image:alt":
      "Plan a route with one of the Porsche Taycan models. Charge map includes Porsche destination chargers.",
    logo: "",
    url: "",
    "twitter:title": "",
    "twitter:description": "",
    "twitter:image": "",
    "twitter:card": "",
  },
};

export default appConfig;
